import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { KeyboardUtilsReact } from "abreact/incubator/ui/utils/KeyboardUtilsReact";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbIcon } from "abreact/misc/AbIcon";
import { AbPseudoButton } from "abreact/misc/AbPseudoButton";
import { AbSize, AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import * as AbHooks from "abreact/utils/AbHooks";
import { KeyValue } from "abweb/utils/KeyboardUtils";
import * as React from "react";

/**
 * The properties for the **AbChiclet** component.
 */

const AbChiclet = (props, ref) => {
  const contextSize = React.useContext(AbSizeContext);
  const [labelText, setLabelText] = React.useState("");
  const labelRef = AbHooks.useMutationObserver(element => {
    setLabelText(element.innerText);
  });
  const onKeyDown = KeyboardUtilsReact.makeKeyHandler([[[KeyValue.DELETE, KeyValue.BACKSPACE], () => {
    props.onClose?.();
  }]]);
  const extraClassNames = [props.onClose && !props.disabled && "ab-chiclet-closeable", props.size ?? contextSize ?? AbSize.MEDIUM, "ab-size-nested"];
  const {
    tabIndex,
    ...componentProps
  } = ReactUtils.inputProps("ab-chiclet", props, extraClassNames);
  const removeButton = props.onClose && !props.disabled ? /*#__PURE__*/React.createElement(AbPseudoButton, {
    onClick: props.onClose,
    icon: "absdk:close",
    ariaLabel: AbReactResources.abChiclet_remove_button_ariaLabel(labelText)
  }) : null;
  const inner = /*#__PURE__*/React.createElement(AbWithTooltip, _extends({}, AbWithTooltip.makeClippedProps(props.tooltip, props.label), {
    clippedTrigger: labelRef
  }), /*#__PURE__*/React.createElement("div", _extends({}, componentProps, {
    ref: ref,
    tabIndex: props.onClick || props.onClose ? tabIndex : undefined,
    onClick: props.onClick
  }, props.eventHandlers, {
    onKeyDown: e => {
      onKeyDown(e);
      props.eventHandlers?.onKeyDown?.(e);
    }
  }), props.icon && /*#__PURE__*/React.createElement(AbIcon, {
    image: props.icon,
    className: "ab-chiclet-icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ab-chiclet-label",
    ref: labelRef
  }, props.label), removeButton));
  return sizeProviderWrapper(inner, props, contextSize);
};
const WrappedAbChiclet = /*#__PURE__*/React.forwardRef(AbChiclet);
export { WrappedAbChiclet as AbChiclet };
//# sourceMappingURL=AbChiclet.js.map
